// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { object, string } from 'prop-types'

const FormatElevation = ({ unitType, rowData }) => {
  const {
    elevation,
    elevationUS,
  } = rowData

  const unit = unitType === 'SI' ? 'm' : 'ft'
  const elev = unitType === 'SI' ? elevation : elevationUS

  return (
    <span title={`${elev} ${unit}`}>{elev}</span>
  )
}

FormatElevation.propTypes = {
  rowData: object.isRequired,
  unitType: string.isRequired,
}

export default FormatElevation
